module.exports = __webpack_public_path__ + "static/media/30.72be1099.mp3";